<template>
  <div class="xcard">
    <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Eventos Masivos </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-select
              v-model="filtro"
              :items="filtros"
              :disabled="loading"
              return-object
              filled
              label="Filtrar"
              class="mt-6"
              dense
            />
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-pencil
              </v-icon>
              Registrar Evento Masivo
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.sucursal`]="{ item }">
          <span>
            [{{ item.sucursal.codigoSucursal }}] {{ item.sucursal.municipio }} {{ item.sucursal.nombre }}
            {{ item.sucursal.direccion }} {{ item.sucursal.telefono }}
          </span>
        </template>

        <template v-slot:[`item.puntoVenta`]="{ item }">
          <span>
            [{{ item.puntoVenta.codigoPuntoVenta }}] ({{ item.puntoVenta.id }}) {{ item.puntoVenta.nombre }},
            {{ item.puntoVenta.descripcion }}
          </span>
        </template>

        <template v-slot:[`item.opciones`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.fechaFin == null"
                class="mr-1"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="emitir(item)"
              >
                mdi-collapse-all
              </v-icon>
            </template>
            <span> Emitir </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="mr-1" color="purple" small v-bind="attrs" v-on="on" @click="verItemFacturas(item)">
                mdi-clipboard-outline
              </v-icon>
            </template>
            <span> Ver Facturas </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.fechaFin == null"
                class="mr-1"
                color="green"
                small
                v-bind="attrs"
                v-on="on"
                @click="verEnvios(item)"
              >
                mdi-check-decagram
              </v-icon>
            </template>
            <span> Ver envios </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                :disabled="item.fechaFin != null"
                class="mr-1"
                color="red"
                small
                v-bind="attrs"
                v-on="on"
                @click="finalizarItem(item)"
              >
                mdi-bomb
              </v-icon>
            </template>
            <span> Finalizar </span>
          </v-tooltip>
          <!-- <v-icon class="mr-2" @click="verItem(item)">
            mdi-eye
          </v-icon> -->
          <!-- <v-icon class="mr-2" @click="finalizarItem(item)">
            mdi-bomb
          </v-icon> -->
        </template>
      </v-data-table>
    </template>

    <EventosReg ref="eventosreg" v-on:newregevento="newregevento" />
    <EventoEmitir ref="eventoemitir" />
    <EventosViewf ref="eventosviewf" />
    <EventoFin ref="eventofin" v-on:fineventomasivo="fineventomasivo" />
  </div>
</template>

<script>
  import EventosReg from '@/views/recibos/emisionmasiva/registrarmasivo.vue';
  import EventoEmitir from '@/views/recibos/emisionmasiva/eventoemitir.vue';
  import EventoFin from '@/views/recibos/emisionmasiva/finalizar.vue';
  import EventosViewf from '@/views/recibos/emisionmasiva/verfacturasmasivas.vue';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loading: false,
      // headers: [
      //   { text: 'Nombre', value: 'nombre' },
      //   { text: 'Municipio', value: 'municipio' },
      //   { text: 'Telefono', value: 'telefono' },
      //   { text: 'Direccion', value: 'direccion' },
      //   { text: 'Codigo Sucursal', value: 'codigoSucursal' },
      //   { text: 'Opciones', value: 'opciones', sortable: false },
      // ],
      filtros: [
        { id: 1, text: 'Todos' },
        { id: 2, text: 'Finalizados' },
        { id: 3, text: 'No Finalizados' },
      ],
      filtro: null,
      headers: [
        { text: 'Sucursal', value: 'sucursal' },
        { text: 'Punto Venta', value: 'puntoVenta' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'fechaInicio', value: 'fechaInicio' },
        { text: 'fechaFin', value: 'fechaFin' },
        { text: 'Opciones', value: 'opciones', sortable: false, width: 130 },
      ],
      dessertscopy: [],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    }),

    components: { EventosReg, EventoEmitir, EventoFin, EventosViewf },

    computed: {
      formTitle() {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item';
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
      dialogDelete(val) {
        val || this.closeDelete();
      },
      filtro: function() {
        if (!this.filtro) return;
        window.console.log(this.filtro);
        this.desserts = [];
        let vue = this;
        if (this.filtro.id == 1) {
          this.dessertscopy.forEach((x) => {
            vue.desserts.push(x);
          });
        } else if (this.filtro.id == 2) {
          this.dessertscopy.forEach((x) => {
            if (x.fechaFin) vue.desserts.push(x);
          });
        } else if (this.filtro.id == 3) {
          this.dessertscopy.forEach((x) => {
            if (!x.fechaFin) vue.desserts.push(x);
          });
        }
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        let vue = this;
        vue.loading = true;
        this.desserts = [];
        this.dessertscopy = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/eventomasivo`,
          headers: {
            apikey: this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.reverse();
            window.console.log('eventos:', data);
            data.forEach((x) => {
              vue.dessertscopy.push(x);
            });
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },

      newregevento(item) {
        let e = this.desserts.find((x) => x.id == item.id);
        if (e) {
          e.codigo = item.codigo;
          e.codigoPuntoVenta = item.codigoPuntoVenta;
          e.numero_documento = item.numero_documento;
          e.codigoSucursal = item.codigoSucursal;
          e.descripcion = item.descripcion;
        } else {
          this.initialize();
        }
      },

      fineventomasivo() {
        this.initialize();
      },

      editItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialog = true;
        this.$refs.eventosreg.openmodal(item);
      },

      emitir(item) {
        this.$refs.eventoemitir.openmodal(item);
      },
      verItemFacturas(item) {
        this.$refs.eventosviewf.openmodal(item);
      },
      verEnvios(item) {
        this.$router.push('/emisionmasivoenvios?ideventomasivo=' + item.id);
      },

      finalizarItem(item) {
        this.$refs.eventofin.openmodal(item);
      },

      deleteItem(item) {
        this.editedIndex = this.desserts.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //this.dialogDelete = true;
        this.$refs.unidadesdel.openmodal();
      },

      deleteItemConfirm() {
        this.desserts.splice(this.editedIndex, 1);
        this.closeDelete();
      },

      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },

      closeDelete() {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
    },
  };
</script>
